import React, {Component} from 'react';
import NotificationSystem from 'reapop';
// import theme from 'reapop-theme-wybo';
import theme from '../../UI/NotificationTheme/NotificationTheme';

class Notification extends Component{
  render(){
    return(
      <div>
        <NotificationSystem theme={theme}/>
      </div>
    );
  }
}

export default Notification;